import { render } from "./BrandShow.vue?vue&type=template&id=3e19135e"
import script from "./BrandShow.vue?vue&type=script&lang=js"
export * from "./BrandShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__